import React from 'react';
import { styles } from './styles';
import { COLORS } from '../../constants';

// Default User Icon SVG (same as used in messages)
const DefaultUserIcon = () => (
  <svg width="60" height="60" viewBox="0 0 24 24" fill="none" stroke={COLORS.primary} strokeWidth="1.5">
    <path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2" />
    <circle cx="12" cy="7" r="4" />
  </svg>
);

const ProfileImage = ({ src, alt }) => {
  // If no profile picture, show default icon
  if (!src) {
    return (
      <div style={{
        ...styles.profileImage,
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        background: `${COLORS.primary}15`
      }}>
        <DefaultUserIcon />
      </div>
    );
  }

  return (
    <img
      src={src}
      alt={alt || 'profile'}
      style={styles.profileImage}
    />
  );
};

export default ProfileImage;